import MobilePersonalNotice from './MobilePersonalNotice';

export default MobilePersonalNotice;
